<script lang="ts">
import './App.css'
import { defineComponent, defineAsyncComponent } from 'vue'

import WebSocketManager from '@/shared/managers/WebSocketManager.vue'
import RouteManager from '@/shared/managers/RouteManager.vue'

import { LazyModules } from './shared/LazyModules'
import TabActiveManager from './shared/managers/TabActiveManager.vue'
import IncomingCallModal from '@/shared/components/IncomingCallModal/IncomingCallModal.vue'
import CallReturnBanner from '@/shared/components/CallReturnBanner/CallReturnBanner.vue'
// Ленивая загрузка: CallPip тянет синглтон liveKit (useLiveKit → CallsStore.get()),
// который нельзя выполнять на этапе загрузки модулей — Vuex-хранилище ещё не
// создано. Динамический import грузит компонент уже в рантайме, когда стор готов.
const CallPip = defineAsyncComponent(() => import('@/shared/components/CallPip/CallPip.vue'))
import ToastContainer from '@/shared/toast/ToastContainer.vue'
import CallMessageNotifications from '@/shared/callNotifications/CallMessageNotifications.vue'
import SecretCallNotice from '@/shared/components/SecretCallNotice/SecretCallNotice.vue'
import {CallInfo, CallsStore} from '@/store/modules/Calls/CallsStore'
import { CallApi } from '@/shared/api/methods/CallApi'
import {ChatsStore} from '@/store/modules/Chats/ChatsStore'
import {ContactsStore} from '@/store/modules/Contacts/ContactsStore'
import { ensureE2EIdentityUploaded } from '@/shared/crypto/bootstrap'

export default defineComponent ({
  components: {
    WebSocketManager,
    RouteManager,
    TabActiveManager,
    IncomingCallModal,
    CallReturnBanner,
    CallPip,
    ToastContainer,
    CallMessageNotifications,
    SecretCallNotice,
  },
  data() {
    return {
      incomingCall: null as CallInfo | null,
    }
  },
  async mounted() {
    setTimeout(async () => {
      const { chatsState } = ChatsStore.get()
      const { callStore, callState } = CallsStore.get()
      const { contactsState } = ContactsStore.get()

      for (const key in LazyModules) {
        LazyModules[key]()
      }
      // Register this device's E2E public key so peers can start secret chats.
      void ensureE2EIdentityUploaded()
      if (chatsState.userId) {
        const history = await CallApi.history(chatsState.userId)
        const incomingCall = history.data.find((item:{status: string, direction: string}) => item.status === 'initiating' && item.direction === 'incoming')
        if (incomingCall) {
          const findChat = contactsState.contacts.find(item => item.user.id ===  incomingCall.other_user.id)
          await callStore.dispatch(async (state) => {
            state.incomingCall = {
              userId: +chatsState.userId,
              callId: incomingCall.call_id,
              chatId: findChat?.chat_id as number,
              callerId: incomingCall.other_user.id,
              type: 'one-to-one',
              call_type: incomingCall.call_type,
              status: 'incoming',
              liveKitRoomName: '',
              liveKitToken: '',
              liveKitUrl: '',
              // Конверт ключа окно входящего возьмёт из calls/active.
              isSecret: !!incomingCall.is_secret,
            }
          })
          this.incomingCall = callState.incomingCall
        }
      }
      window.addEventListener('show-incoming-call', this.handleShowIncomingCall)
    }, 500)
  },
  unmounted() {
    window.removeEventListener('show-incoming-call', this.handleShowIncomingCall)
  },
  methods: {
    handleShowIncomingCall(event: CustomEvent) {
      this.incomingCall = event.detail
    },
  },
})
</script>

<template>
  <router-view />
  <IncomingCallModal
    v-if="incomingCall"
    :call="incomingCall"
    @close="incomingCall = null"
  />
  <WebSocketManager />
  <TabActiveManager />
  <RouteManager />
  <CallReturnBanner />
  <CallPip />
  <ToastContainer />
  <CallMessageNotifications />
  <SecretCallNotice />
</template>
